import { render, staticRenderFns } from "./SelectThemeRibbon.vue?vue&type=template&id=43716e03&scoped=true"
import script from "./SelectThemeRibbon.vue?vue&type=script&lang=js"
export * from "./SelectThemeRibbon.vue?vue&type=script&lang=js"
import style0 from "./SelectThemeRibbon.vue?vue&type=style&index=0&id=43716e03&prod&lang=css"
import style1 from "./SelectThemeRibbon.vue?vue&type=style&index=1&id=43716e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43716e03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VLazy,VResponsive})
